import React from "react";
import { useRenewal } from "../RenewalContext";

/**
 * Property-manager contact details shown on the confirmation screens.
 *
 * Only the company name is available on PolicySummary today; phone, email and
 * website will come from the account record once the backend lands, so the
 * rows render only when populated rather than showing empty labels.
 */
const PmContactCard: React.FC = () => {
  const { policy } = useRenewal();
  const account = policy?.account as
    | { companyName?: string; phone?: string; email?: string; website?: string }
    | null
    | undefined;

  if (!account?.companyName) return null;

  const rows = [
    { label: "Phone", value: account.phone },
    { label: "Email", value: account.email },
    { label: "Website", value: account.website },
  ].filter((r) => r.value);

  return (
    // Shrink-to-fit and centred: the confirmation screens are centred, and a
    // full-width card around four short lines leaves a lot of dead space.
    // `inline-block` sizes the box to its longest line.
    <div className="mt-6 flex justify-center">
      <div className="inline-block rounded-xl bg-white px-6 py-4 text-left shadow-sm">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-muted">
          Your property manager
        </p>
        <p className="font-semibold text-primary">{account.companyName}</p>
        {rows.map((r) => (
          <p key={r.label} className="mt-1 text-sm text-gray-600">
            <strong className="font-semibold text-primary">{r.label}:</strong>{" "}
            {r.value}
          </p>
        ))}
      </div>
    </div>
  );
};

export default PmContactCard;
